<template>
    <div id="fd-xwxx">
        <my-title the-title="行为信息"/>
            <van-cell-group class="fd-com-scroll" ref="jcbqxwxx">
                <van-field
                    v-model="formData.nXwbqsxTxt"
                    class="special-readonly"
                    required
                    clearable
                    readonly
                    label="行为保全事项"
                    right-icon="arrow"
                    placeholder="请选择行为保全事项"
                    @click="showXwbqsx = true"
                ></van-field>
                <van-popup v-model="showXwbqsx" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="codeList_301250"
                        :default-index="0"
                        @cancel="showXwbqsx = false"
                        @confirm="onSxsmConfirm"
                    ></van-picker>
                </van-popup>
                <!--保全开始日期-->
                <van-field
                    v-model="formData.dBqksrq"
                    class="special-readonly"
                    required
                    clearable
                    readonly
                    label="保全开始日期"
                    right-icon="arrow"
                    placeholder="请选择保全开始日期"
                    @click="showBqksrq = true"
                ></van-field>
                <van-popup v-model="showBqksrq" position="bottom">
                    <van-datetime-picker v-model="bqksrqCurrentDate" type="date" @confirm="onBqrqConfirm('1')" @cancel="onBqrqcancelFn('1')" />
                </van-popup>
                <!-- 保全结束日期-->
                <van-field
                    v-model="formData.dBqjsrq"
                    class="special-readonly"
                    required
                    clearable
                    readonly
                    label="保全结束日期"
                    right-icon="arrow"
                    placeholder="请选择保全结束日期"
                    @click="showBqjsrq = true"
                ></van-field>
                <van-popup v-model="showBqjsrq" position="bottom">
                    <van-datetime-picker v-model="bqjsrqCurrentDate" type="date"  @confirm="onBqrqConfirm('2')" @cancel="onBqrqcancelFn('2')" />
                </van-popup>
                <van-field
                    class="fd-textarea"
                    type="textarea"
                    rows="2"
                    show-word-limit
                    autosize
                    required
                    v-model="formData.cSm"
                    label="事项说明"
                    maxlength="200"
                    placeholder="请输入事项说明"
                />

            </van-cell-group>

            <div class="fd-com-btn-container">
                <van-button
                    v-if="formData.xwxxId"
                    type="info"
                    round
                    plain
                    @click="addAndReturn"
                >
                    确定
                </van-button>
                <van-button
                    v-if="!formData.xwxxId"
                    type="info"
                    round
                    plain
                    @click="addAndReturn"
                >
                    添加
                </van-button>
                <van-button
                    v-if="!formData.xwxxId"
                    type="info"
                    round
                    @click="addAndContinue"
                >
                    确认并继续添加
                </van-button>
            </div>
    </div>
</template>

<script>
import MyTitle from '../../../components/common/myTitle';
import {mapGetters} from "vuex";
import validate from "@/utils/validator/validator";
import {saveJcbqData} from '../../../api/guarantee';
import {typeXwbqsx} from "../../../filters/index";
import {dBqksrqRule, dBqjsrqRule} from "@/utils/validator/rules";
import {getId} from "@/api/common";

export default {
    name: "addXwxx",
    components: {
        MyTitle
    },
    data() {
        return {
            bqksrqCurrentDate: new Date(),
            bqjsrqCurrentDate: new Date(),
            formData:{
                xwxxId: null, // id
                nXwbqsx:'1',
                nXwbqsxTxt:'中止支付信用证项下款项',
                cSm:'',
                // 保全开始日期
                dBqksrq: '',
                // 保全结束日期
                dBqjsrq: '',
                cjbid:null,
                cbqid:null,
                cid: null
            },
            showXwbqsx:false,
            showBqksrq:false,
            showBqjsrq:false,
        };
    },
    computed: {
        ...mapGetters(['codeList_301250', 'jcbqxwxxData']),
    },
    methods: {
        /**
         * 请求数据
         * @param {Object} params 请求参数
         * */
         requestData(params) {
            return this.$axios.get('ssbq/api/bqsqinfo', params);
        },
        onSxsmConfirm:function(item){
            this.formData.nXwbqsx=item.keyId;
            this.formData.nXwbqsxTxt=item.text;
            this.showXwbqsx = false;
            console.log('--onSxsmConfirm 111',item);
            console.log('--onSxsmConfirm 222',this.formData);
        },
        onBqrqcancelFn(item) {
            if (item === '1') {
                this.showBqksrq = false;
            }
            if (item === '2') {
                this.showBqjsrq = false;
            }
        },
        timeFormat(currentTime) { // 时间格式化 2019-09-08
            let time =  new Date(currentTime);
            let year = time.getFullYear();
            let month = this.showTime(time.getMonth() + 1);
            let day = this.showTime(time.getDate());
            return year + '-' + month + '-' + day
        },
        // 封装一个不够两位数就补零的函数
        showTime(t) {
            let time
            time = t >= 10 ? t : '0' + t
            return time
        },
        onBqrqConfirm: function(item){
            if (item === '1') {
                this.formData.dBqksrq = this.timeFormat(this.bqksrqCurrentDate);
                this.showBqksrq = false;
            }
            if (item === '2') {
                this.formData.dBqjsrq = this.timeFormat(this.bqjsrqCurrentDate);
                this.showBqjsrq = false;
            }
        },
        //组装提交数据
        // params(){
        //     let {xwxxId,cSxsm,nXwbqsx,dBqksrq,dBqjsrq} = this.formData;
        //     return {cId:xwxxId,cSxsm,nXwbqsx,dBqksrq,dBqjsrq}
        // },
        initForm() {
            let obj = {
                nXwbqsx: 1,
                dBqksrq:'',
                dBqjsrq:'',
                cSm: '',
                cjbid:null,
                cbqid:null,
                cid: null
            }
            for (let key in obj) {
                this.formData[key] = obj[key]
            }
        },
         params() {
             let jbJbxx = [];
             let jcbqxwxx = [];
             console.log(this.jcbqxwxxData)
             if (this.jcbqxwxxData.length > 0 ) {
                 jcbqxwxx = this.jcbqxwxxData
             }
             // alert(typeof this.formData)
             // jcbqxwxx.push(this.jcbqxwxxData)
             this.formData.nXwbqsx =  Number(this.formData.nXwbqsx);
             jcbqxwxx.push(this.formData)
             jbJbxx = JSON.parse(sessionStorage.getItem('jcbqjbxx'))
             return {
                jbJbxx: jbJbxx,
                jbCcxxs: [],
                jbZjxxs: [],
                jbXwxxs: jcbqxwxx,
             }
        },
        validateFormData(){
            // 校验规则
            let descriptor={};
            descriptor.dBqksrq = dBqksrqRule;
            descriptor.dBqjsrq = dBqjsrqRule;
            return validate(descriptor, this.formData);
        },
        async onSubmit(fn){
            let params = await this.params()
            // this.formData.cjbid = sessionStorage.getItem('cId');
            // this.formData.cbqid = sessionStorage.getItem('bqid');
            this.formData.cjbid = this.$route.query.cId;
            this.formData.cbqid = this.$route.query.bqid;
            var xwxxId = sessionStorage.getItem("bqXwxxId");
            if (xwxxId) {
                this.formData.cid = xwxxId;
            } else {
                this.formData.cid = await this.myId(0);
            }
            console.log('--数据提交 111',this.formData,params);
            this.validateFormData().then(() => {
                saveJcbqData(params).then((res)=>{
                    console.log('--addXcxXw 123',res);
                    if (res.code ===200) {
                        this.$notify({'type': 'success', 'message': '操作成功'});
                    } else {
                        this.$notify(res.message);
                    }
                    fn();
                }).catch((error) => {  console.log(error) });
            });
        },
        addAndReturn(){
            this.onSubmit(()=>{
                this.$router.push({
                    path: '/relievePreservationNew',
                    query: {
                        bqid: this.$route.query.bqid,
                        cId: this.$route.query.cId,
                    }
                })
            });
        },
        addAndContinue(){
            this.onSubmit(()=>{
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            });
        },
        initCodeType(){
            this.$store.dispatch('GetCodeType', 301250)
        },
        initData(){

            // getXcxXw({id:this.formData.cid}).then(res=>{
            //     console.log('--initData 123',res);
                var data=this.formData;
            // alert(data.nXwbqsx)
                this.formData.nXwbqsx=data.nXwbqsx;
                this.formData.nXwbqsxTxt=typeXwbqsx(data.nXwbqsx);
                this.formData.cSm=data.cSm;
                this.formData.dbqksrq = data.dbqksrq;
                // this.formData.dbqjsrq = dateFormat(data.dbqjsrq, "yyyy-MM-dd");
                this.formData.dbqjsrq = data.dbqjsrq;
            // });
        },
        /**
         * 获取id
         * */
        myId(i) {
            return new Promise((resolve, reject) => {
                i++
                if (i > 3) {
                    this.$notify('系统错误，请重试!');
                    reject();
                } else {
                    getId().then((res) => {
                        resolve(res.data)
                    }).catch(() => {
                        return this.myId(i);
                    })
                }
            })
        },
    },
    created() {
        console.log('--created xwxx');
        this.initCodeType()
        var jcxwxxItem = sessionStorage.getItem("jcxwxxItem");
        // if(jcxwxxItem){
        //     this.formData = JSON.parse(jcxwxxItem);
        //     this.initData();
        // }
        var xwxxId = sessionStorage.getItem("bqXwxxId");
        if(jcxwxxItem){
            this.formData = JSON.parse(jcxwxxItem);
            this.formData.xwxxId = xwxxId;
            this.initData();
        }
    },
    mounted() {
        this.timeFormat(new Date());
    },
    // 路由跳转之前保存当前滚动条的位置。
    beforeRouteLeave(to, from, next) {
        sessionStorage.removeItem("jcxwxxItem");
        sessionStorage.removeItem("bqXwxxId");
        next();
    },

}
</script>

<style lang="less" scoped>

#fd-xwxx{
    width: 100%;
    height: 100%;
    overflow: hidden;

        .fd-textarea{
            height: auto;
        }
}
</style>
